import styled from "styled-components"
import { validColor, darkBorder, darkFontColor, darkBackground } from "./helpers"

export const StyledDropdownContainer = styled.div`
  position: relative;
  background: ${props => props.theme.colors.white};
  border: 1px solid rgba(0,0,0,0.25);
  border-radius: 4px;
  display: flex;

  & ul {
    margin: 0;
  }
  ${props => props.loading && `
        opacity: .5;
        pointer-events: none;
    `}
`

export const StyledDropDownHeader = styled.div`
  font-family: 'EFCircularWeb-Book';
  line-height: 20px;
  font-size: 16px;
  margin: 0;
  -webkit-appearance: none;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;

  & svg{
    color: ${props => props.theme.colors.darkGrey} !important;
  }  

`

export const StyledDropDownListContainer = styled.div`
  position: absolute;
  display: block;
  height: auto;
width: auto;
  z-index: 1;
  top: calc(100% - 1px);

  & ul {
    padding: 8px;
    margin: 0;
    width: 100%;
    box-sizing: border-box;
    border-radius: 4px;
    cursor: pointer;
    max-height: 150px;
    overflow-y: scroll;
    list-style: none;
    font-family: 'EFCircularWeb-Book';
    background: ${props => props.theme.colors.white};
    border: 1px solid rgba(0,0,0,0.25);
  }
`

export const StyledDropdownListItem = styled.li`
  display: block;
  position: relative;
  padding: .8rem;
  margin: 0;
  font-size: 16px;
    line-height: 20px;
    color: ${props => props.theme.colors.darkGrey} !important;

  :hover {
    background-color: rgba(0,0,0,0.05);
  }

  :before {
    content: none !important;
  }
`

export const StyledFlagContainer = styled.div`
    display: flex;
    align-items: center;

  & img {
    margin-right: 8px;
    height: 16px !important;
    width: auto !important;
  }

  & p, & span{
    margin: 0;
    font-size: 16px;
    line-height: 20px;
    color: ${props => props.theme.colors.darkGrey} !important;
  }


`
